// extracted by mini-css-extract-plugin
export default {"modalForm":"ModalForm_modalForm__m17Aq","active":"ModalForm_active__UJPSb","modalFormContent":"ModalForm_modalFormContent__MgVRf","close_icon":"ModalForm_close_icon__HpLBH"};